var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlatreanlaeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.614,2.5a1.145,1.145,0,0,0-.639.332L10.5,4.283a1.625,1.625,0,0,0-.4.8l-.051.379a1.2,1.2,0,0,1-.457.731l-.14.094a1.274,1.274,0,0,0-.475.728l-.17.97a1.555,1.555,0,0,1-.441.774L6.931,9.994a2.588,2.588,0,0,1-.812.438l-1.839.53a1.318,1.318,0,0,0-.684.543L2.941,12.68c-.127.227-.018.413.242.413h9.26a.474.474,0,0,0,.473-.472V2.97C12.916,2.71,12.78,2.5,12.614,2.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.265,4.127A.681.681,0,1,0,6.6,3.433.681.681,0,0,0,7.265,4.127Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.794,10.259a.278.278,0,0,0,.245-.128l.986-1.387a.281.281,0,0,0,.054-.254l-.035-1.4.244.05.434.1-.016.807a.289.289,0,0,0,.2.368.245.245,0,0,0,.085.014.3.3,0,0,0,.295-.213L7.6,7.138a.26.26,0,0,0-.032-.231l-.658-.643.464-.929L8.6,5.582c.024,0,.048.013.084.014a.311.311,0,0,0,.3-.225A.306.306,0,0,0,8.769,5L8.25,4.847l1.4-1.063a.321.321,0,0,0,.057-.424A.311.311,0,0,0,9.276,3.3l-1.434.9-.915.132a.343.343,0,0,0-.257.116L5.148,6.226a1.243,1.243,0,0,0-.238.325.158.158,0,0,0-.014.073.2.2,0,0,0,.022.122l.389,1.578L4.549,9.781a.314.314,0,0,0,.245.478Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlatreanlaeg);
export default __webpack_public_path__ + "static/media/KLATREANLAEG.df8dca98098f2c133bb54a05deafdcf6.svg";
export { ForwardRef as ReactComponent };